<script lang="ts" setup>
import { ref, toRef, onMounted, onBeforeUnmount, computed } from 'vue'
import { NumberUtils } from '~/utils'
import { useCountdown } from '~/composables/common/use-countdown'
import AnimatedNumber from '~/components/common/animated-number.vue'

const props = defineProps({
  item: {
    type: Object
  }
})
const item = toRef(props, 'item')
const userNumber = ref()
const intervalId = ref()
const { countdownNumber, calculateCountdown } = useCountdown()
onMounted(() => {
  const minRandomValue = 5000
  const maxRandomOffset = 7000
  userNumber.value = NumberUtils.formatNumberWithCommas(Math.floor(Math.random() * maxRandomOffset) + minRandomValue)
  calculateCountdown(item.value?.time)
  intervalId.value = setInterval(() => {
    calculateCountdown(item.value?.time)
  }, 1000)
})
onBeforeUnmount(() => {
  clearInterval(intervalId.value)
})

const betNumber = computed(() => {
  return parseInt(userNumber.value?.replace(/,/g, ''), 10)
})
</script>
<template>
  <div :class="['box-area', item?.class]">
    <div class="box-area--left">
      <p class="box-area__title">{{ item?.name }}</p>
      <p class="box-area__sub">
        <AnimatedNumber :number="betNumber" suffix="đã cược" />
      </p>
    </div>
    <div class="box-area--right">
      <p class="box-area__text effect-shine effect-shine__target">Phiên xổ tiếp theo</p>
      <ul class="box-area__numbers">
        <li>{{ countdownNumber.hours }}</li>
        <li>{{ countdownNumber.minutes }}</li>
        <li>{{ countdownNumber.seconds }}</li>
      </ul>
    </div>
  </div>
</template>
<style scoped lang="scss">
@import '~scssAsset/desktop/pages/lobby-games/next-lottery-item.scss';
</style>
